export default __webpack_public_path__ + "static/media/handoffs.9fc01fc9.png";